import { Suspense, lazy } from 'react';
import { Flex } from 'antd';
import { useAppSelector } from 'app/hooks';
import useIsMobile from 'hooks/useIsMobile';
import Spin from 'components/Spin';
import If from 'components/If';
import { getFromBrandConfig } from 'brand-config';
import { selectUserSignInStatus } from 'services/session/sessionSelectors';
import CustomerServiceHelp from './CustomerServiceHelp';
import styles from './Menu.module.scss';

/* Lazy load components */
const MenuPopOver = lazy(() => import('./MenuPopOver'));
const MenuDrawer = lazy(() => import('./MenuDrawer'));
const Notifications = lazy(() => import('./notifications'));

// Menu Component
function Menu() {
  const isMobile = useIsMobile();
  const isLogin = useAppSelector(selectUserSignInStatus);
  const hasCustomerServiceSupport = getFromBrandConfig(
    'hasCustomerServiceSupport',
  );

  if (isMobile) {
    return (
      <Flex align='center' className='gap16'>
        <Suspense fallback={<Spin />}>
          <Notifications />
        </Suspense>
        <Suspense fallback={<Spin />}>
          <MenuDrawer isLogin={isLogin} />
        </Suspense>
      </Flex>
    );
  }

  if (isLogin) {
    return (
      <Flex className={`${styles.menuContainer} gap16`}>
        <CustomerServiceHelp />
        <If condition={hasCustomerServiceSupport}>
          <div className={styles.verticalDivider} />
        </If>
        <Flex align='center' className='gap20'>
          <Suspense fallback={<Spin />}>
            <Notifications />
          </Suspense>
          <Suspense fallback={<Spin />}>
            <MenuPopOver />
          </Suspense>
        </Flex>
      </Flex>
    );
  }

  return <CustomerServiceHelp alignCenter />;
}

export default Menu;
